import { useContext } from 'react';
import { Card, StyledFlex, SwitchThemeContext } from '@tryhackme/thm-ui-components';
import { StyledHeaderText } from 'src/features/module/components/module.styles';
import { ThemeColorMode } from 'src/common/enums';
import { StyledModule } from './next-modules.styles';
import { NextModulesProps } from './next-modules.types';
export const NextModules: React.FC<NextModulesProps> = ({
  title,
  modules,
  moduleAriaLabel
}) => {
  const {
    theme
  } = useContext(SwitchThemeContext);
  const isDark = theme === ThemeColorMode.DARK;
  return <Card data-sentry-element="Card" data-sentry-component="NextModules" data-sentry-source-file="next-modules.tsx">
      <StyledFlex flexDirection="column" alignItems="flex-start" alignContent="flex-start" gap="2.4rem" data-sentry-element="StyledFlex" data-sentry-source-file="next-modules.tsx">
        <StyledHeaderText data-sentry-element="StyledHeaderText" data-sentry-source-file="next-modules.tsx">{title}</StyledHeaderText>
        <StyledFlex flexDirection="column" gap="0" data-sentry-element="StyledFlex" data-sentry-source-file="next-modules.tsx">
          {modules?.map(({
          id,
          title: moduleTitle,
          summary,
          image,
          moduleURL
        }) => <StyledModule data-testid="module-link" to={`/module/${moduleURL}`} key={id} $isDark={isDark}>
              <img src={image} alt={`${moduleAriaLabel} ${moduleTitle}`} />
              <div>
                <p>
                  <strong>{moduleTitle}</strong>
                </p>
                <p>{summary}</p>
              </div>
            </StyledModule>)}
        </StyledFlex>
      </StyledFlex>
    </Card>;
};